import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AdminLoginModal from './AdminLoginModal';

type Props = {
  children: React.ReactElement;
  requireAdmin?: boolean;
};

const ProtectedRoute: React.FC<Props> = ({ children, requireAdmin }) => {
  const { user } = useAuth();

  if (!user && requireAdmin) {
    return <AdminLoginModal />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    requireAdmin &&
    user.role !== 'admin' &&
    user.role !== 'superadmin'
  ) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;

